<template>
  <div class="component-form-search-cities">
    <transition name="fade" mode="out-in">
      <div v-if="loading">
        <div class="space-40"></div>
        <loading></loading>
        <div class="space-40"></div>
      </div>
      <div v-else="">
        <div class="list-group margin-bottom-0" v-if="cities.length > 0">
          <a href="#" style="border-radius: 0;" class="list-group-item" v-for="c in cities" @click="setCity(c)" :class="{'active': c.id == city.id}">{{ c.name }} - {{ c.state.initials }}</a>
        </div>
      </div>
    </transition>
    <!--
    <transition name="fade" mode="out-in">
      <loading v-if="loading"/>
      <div v-else="">
        <vue-google-autocomplete
          ref="address"
          id="map"
          classname="form-control"
          placeholder="Digite o nome da cidade"
          @placechanged="getAddressData"
          country="br"
          types="(cities)"
        >
        </vue-google-autocomplete>
      </div>
    </transition>
    -->
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import VueGoogleAutocomplete from 'vue-google-autocomplete'

  export default{
    name: 'FormSearchCities',
    components: {
      VueGoogleAutocomplete
    },
    props: [],
    data () {
      return {
        loading: true,
        cities: []
      }
    },
    computed: {
      ...mapState({
        user: state => state.user,
        city: state => state.city
      })
    },
    mounted () {
      this.getCities()
    },
    methods: {
      setCity (city) {
        this.saveCity(city)
        this.$emit('selected', city)
        /*
        switch (id) {
          case 1: this.getCity('Belo Horizonte', 'MG'); break
          case 2: this.getCity('Betim', 'MG'); break
          case 3: this.getCity('Contagem', 'MG'); break
          case 3211: this.getCity('Igarapé', 'MG'); break
          case 3385: this.getCity('Mário Campos', 'MG'); break
          case 3480: this.getCity('Nova Lima', 'MG'); break
          case 4: this.getCity('São Joaquim de Bicas', 'MG'); break
          case 3949: this.getCity('Sarzedo', 'MG'); break
          case 8859: this.getCity('Águas de Lindóia', 'SP'); break
          case 9318: this.getCity('Lindóia', 'SP'); break
          case 9684: this.getCity('Serra Negra', 'SP'); break
          case 9693: this.getCity('Socorro', 'SP'); break
        }
        */
      },
      getAddressData (addressData) {
        let city = addressData.locality
        let initials = addressData.administrative_area_level_1
        this.getCity(city, initials)
      },
      getCities () {
        this.loading = true
        this.$http.get('active_cities')
          .then((response) => {
            this.cities = response.data
            this.loading = false
          }, (error) => {
            console.log(error)
            this.loading = false
          })
      },
      ...mapActions([
        'saveCity',
        'unsetCity'
      ])
    }
  }
</script>


// WEBPACK FOOTER //
// FormSearchCities.vue?16051838